import React from 'react';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import AppTheme from '../styles/theme';

export default class MuiContainer extends React.Component {
	static propTypes = {
		children: React.PropTypes.node,
	};

	static childContextTypes = {
		muiTheme: React.PropTypes.object,
	};

	getChildContext() {
		return {
			muiTheme: getMuiTheme(AppTheme),
		};
	}

	render() {
		return this.props.children;
	}
}



// WEBPACK FOOTER //
// ./src/container/MuiContainer.js